import {APPEAL_PHONE_LIST, APPEAL_UPDATE, APPEAL_CLEAN} from '../actions/ActionTypes';

export function Aphonelist(state = [], action) {
    switch (action.type) {
        case APPEAL_PHONE_LIST:
            if (action.data) {
                state = action.data;
                return state;
            }
            return [];
        default:
            return state;
    }
}
const initialState = {
    titleName: '', // 卡片右侧展示内容，企业名称或号码标记
    appealType: 1, // 1：标记申诉 2：占用申诉
    curStep: 1, // 步骤
    phone: '',
    phoneErr: '',
    phoneName: '',
    phoneList: [],
    hasSearchUrl: false, // 外链跳转
    companyName: '', // 企业名称
    attributionType: '',
    cert: [],
    certErr: '',
    email: '',
    emailErr: '',
    emailCode: '',
    emailCodeErr: '',
    isRead: false,
    isReadErr: '',
    companyQualify: [],
    companyAddress: '',
    nameGov: '',
    social: [],
    questionImg: [],
    questionType: 0,
    questionContent: '',
    isShowDefaultGov: true,
    phoneMode: '', // customer || reports || poi
    reportTag: '', // reports类型时，需要传入tag值

};
export function appealReducer(state = initialState, action) {
    switch (action.type) {
        case APPEAL_UPDATE:
            return {
                ...state,
                ...action.data
            };
        case APPEAL_CLEAN: {
            return {
                ...initialState
            };
        }
        default:
            return state;
    }
}
